import React from 'react'
import { CheckoutPage } from '../../model'
import { useIsDesignLanguage, DesignLanguage } from '@afterpaytouch/core'
import { ArcadeSummaryPage } from '../summary-arcade'
import { BronteSummaryPage } from '../summary-bronte'
import { SummaryNotificationProvider } from '../../component'
import { useIsAppleRetailOrder } from '../../state/checkout/hooks'
import { AppleRetailSummaryPage } from '../summary-apple-retail'
import { useIsConsumerLendingOrder, useIsPayMonthlySummaryRedesignEnabled } from '../../state/consumerLending/hooks'
import { PayMonthlySummaryPage } from '../summary-pay-monthly'
import { PayMonthlySummaryRedesignedPage } from '../summary-pay-monthly-redesign'

export const SummaryPage: CheckoutPage = () => {
  const isArcadeDesignLanguage = useIsDesignLanguage(DesignLanguage.Arcade)
  const isAppleRetailOrder = useIsAppleRetailOrder()
  const isConsumerLendingOrder = useIsConsumerLendingOrder()
  const isPayMonthlySummaryRedesignEnabled = useIsPayMonthlySummaryRedesignEnabled()

  let SummaryComponent = BronteSummaryPage

  if (isAppleRetailOrder) {
    SummaryComponent = AppleRetailSummaryPage
  } else if (isConsumerLendingOrder) {
    // CASHDAP-3090: gate the redesigned PM summary behind `checkout-pay-monthly-summary-redesign`.
    SummaryComponent = isPayMonthlySummaryRedesignEnabled ? PayMonthlySummaryRedesignedPage : PayMonthlySummaryPage
  } else if (isArcadeDesignLanguage) {
    SummaryComponent = ArcadeSummaryPage
  }

  // TODO: Fix rerender flashing between diff summary component causing Arcade Summary toast to show up during manual page refresh, useIsAppleRetailOrder flag value should cache

  return (
    <SummaryNotificationProvider>
      <SummaryComponent />
    </SummaryNotificationProvider>
  )
}
